import { FaStar, FaTrophy, FaLevelUpAlt, FaPenFancy, FaTimes } from "react-icons/fa";
import { useI18n } from "../i18n/useI18n";
import type { CelebrationEvent } from "../context/celebrationTypes";

const iconByType: Record<string, React.ReactNode> = {
  rating: <FaStar />,
  achievement: <FaTrophy />,
  level_up: <FaLevelUpAlt />,
  challenge: <FaTrophy />,
  review: <FaPenFancy />
};

function CelebrationModal({ events = [], onClose }: { events?: CelebrationEvent[]; onClose?: () => void }) {
  const { t } = useI18n();
  if (!events.length) return null;

  const ownCount = events.filter((event) => event.scope !== "friend").length;
  const friendCount = events.length - ownCount;
  const title = ownCount && friendCount
    ? "Кинособытия"
    : friendCount
    ? "Новости друзей"
    : "Поздравляем!";
  const translatedTitle = t(title);

  return (
    <div className="celebration-modal" role="presentation" onMouseDown={onClose}>
      <section
        className="celebration-modal__card"
        role="dialog"
        aria-modal="true"
        aria-label={translatedTitle}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button className="celebration-modal__close" type="button" onClick={onClose} aria-label={t("Закрыть")}>
          <FaTimes />
        </button>
        <div className="celebration-modal__glow" aria-hidden="true" />
        <p className="celebration-modal__eyebrow">{t(friendCount ? "Лента ожила" : "Новая веха")}</p>
        <h2>{translatedTitle}</h2>
        <div className="celebration-modal__events">
          {events.map((event, index) => (
            <article className={`celebration-event celebration-event--${event.type || "default"}`} key={event.key || index}>
              <div className="celebration-event__icon">{iconByType[event.type] || <FaTrophy />}</div>
              <div>
                <h3>{t(event.title)}</h3>
                {event.description && <p>{t(event.description)}</p>}
              </div>
            </article>
          ))}
        </div>
        <button className="celebration-modal__ok" type="button" onClick={onClose}>{t("Отлично")}</button>
      </section>
    </div>
  );
}

export default CelebrationModal;
